import _extends from "@babel/runtime/helpers/extends";

/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useTab } from '../hooks';
export default function Tab(_ref) {
  var children = _ref.children,
      testId = _ref.testId;
  var tabAttributes = useTab();
  return jsx("div", _extends({
    "data-testid": testId
  }, tabAttributes), children);
}